import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
`;

export const Header = styled.header`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const LogoImage = styled.img`
    max-height: 48px;
    max-width: 180px;
    object-fit: contain;
`;

export const HeroSection = styled.div`
    width: 100%;
    padding: 8px 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.3;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const Description = styled.p<{ $color: string }>`
    font-size: 14px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#718096'}cc;
    margin: 0;
    text-align: center;
    line-height: 1.5;
`;

export const ContentSection = styled.div`
    width: 100%;
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Subtitle = styled.h2<{ $color: string }>`
    font-size: 16px;
    font-weight: 700;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
`;

export const Paragraph = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #555;
    margin: 0;
    line-height: 1.6;
    text-align: justify;

    b {
        font-weight: 700;
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    border-top: 1px solid #e2e8f0;
`;

export const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 20px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
`;
